import React, { Fragment, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import CustomSlider from "../Components/CustomSlider";
import Reserve from "../Components/ReserveSlider";
import OffSlider from "../Components/OffSlider";
import AdvertisingBoxes from "../../Home/Components/AdvertisingBoxes";
import Mobile from "../../../Common/Mobile";
import Search from "../../Home/Components/Search";
import Cities from "../Components/Cities";
import { useReserve } from "../Hooks";
import ReserveBox from "../Components/ReserveBox";
import SelectCity from "../Components/SelectCity";
import { Helmet } from "react-helmet";

function ReservePage() {
  const { data, loading, getData, renderCategory } = useReserve();
  const { pathname } = useLocation();
  const renderTitle = () => {
    switch (pathname) {
      case "/pool":
        if (loading) {
          return {
            title: "رزرو استخر و مجموعه های آبی | نیکوتن",
            desc: `معرفی، اطلاع رسانی و رزرو آنلاین استخر و پارک های آبی کشور
رزرو استخرهای مشهد، رزرو استخرهای تهران، رزرو استخرهای شاهرود، رزرو استخرهای نیشابور در نیکوتن فعال می باشد.
`,
          };
        } else {
          if (data.contentbox) {
            return {
              title:
                data.contentbox.seo.title ||
                "رزرو استخر و مجموعه های آبی | نیکوتن",
              desc:
                data.contentbox.seo.seoDescription ||
                `معرفی، اطلاع رسانی و رزرو آنلاین استخر و پارک های آبی کشور
رزرو استخرهای مشهد، رزرو استخرهای تهران، رزرو استخرهای شاهرود، رزرو استخرهای نیشابور در نیکوتن فعال می باشد.
`,
            };
          } else {
            return {
              title: "رزرو استخر و مجموعه های آبی | نیکوتن",
              desc: `معرفی، اطلاع رسانی و رزرو آنلاین استخر و پارک های آبی کشور
رزرو استخرهای مشهد، رزرو استخرهای تهران، رزرو استخرهای شاهرود، رزرو استخرهای نیشابور در نیکوتن فعال می باشد.
`,
            };
          }
        }

        break;
      case "/gym":
        if (loading) {
          return {
            title: "رزرو باشگاه بدنسازی | نیکوتن",
            desc: `باشگاه های بدنسازی اطراف خودتو به راحتی پیدا کن. معرفی، اطلاع رسانی رزرو آنلاین باشگاه های بدنسازی مشهد، تهران، نیشابور، شاهرود و سمنان از طریق نیکوتن. معرفی بهترین باشگاه های بدنسازی`,
          };
        } else {
          if (data.contentbox) {
            return {
              title:
                data.contentbox.seo.title || "رزرو باشگاه بدنسازی | نیکوتن",
              desc:
                data.contentbox.seo.seoDescription ||
                `باشگاه های بدنسازی اطراف خودتو به راحتی پیدا کن. معرفی، اطلاع رسانی رزرو آنلاین باشگاه های بدنسازی مشهد، تهران، نیشابور، شاهرود و سمنان از طریق نیکوتن. معرفی بهترین باشگاه های بدنسازی`,
            };
          } else {
            return {
              title: "رزرو باشگاه بدنسازی | نیکوتن",
              desc: `باشگاه های بدنسازی اطراف خودتو به راحتی پیدا کن. معرفی، اطلاع رسانی رزرو آنلاین باشگاه های بدنسازی مشهد، تهران، نیشابور، شاهرود و سمنان از طریق نیکوتن. معرفی بهترین باشگاه های بدنسازی`,
            };
          }
        }

      case "/salon":
        if (loading) {
          return {
            title: "رزرو سالن های ورزشی | نیکوتن",
            desc: `سامانه جامع رزرو آنلاین و اجاره اماکن و سالن های ورزشی کشور با تخفیف های ویژه و امتیازات متنوع به صورت کاملا آنلاین. رزرو سالن های ورزشی تهران، رزرو سالن های ورزشی مشهد و ...`,
          };
        } else {
          if (data.contentbox) {
            return {
              title:
                data.contentbox.seo.title || "رزرو سالن های ورزشی | نیکوتن",
              desc:
                data.contentbox.seo.seoDescription ||
                `سامانه جامع رزرو آنلاین و اجاره اماکن و سالن های ورزشی کشور با تخفیف های ویژه و امتیازات متنوع به صورت کاملا آنلاین. رزرو سالن های ورزشی تهران، رزرو سالن های ورزشی مشهد و ...`,
            };
          } else {
            return {
              title: "رزرو سالن های ورزشی | نیکوتن",
              desc: `سامانه جامع رزرو آنلاین و اجاره اماکن و سالن های ورزشی کشور با تخفیف های ویژه و امتیازات متنوع به صورت کاملا آنلاین. رزرو سالن های ورزشی تهران، رزرو سالن های ورزشی مشهد و ...`,
            };
          }
        }

      default:
        return {
          title: "",
          desc: "",
        };
        break;
    }
  };
  useEffect(() => {
    getData();
  }, [pathname]);

  const rendeKeyWords = () => {
    let res = "";
    if (!loading) {
      if (
        data.contentbox &&
        data.contentbox.seo &&
        data.contentbox.seo.seoKeyword &&
        Array.isArray(data.contentbox.seo.seoKeyword)
      ) {
        data.contentbox.seo.seoKeyword.map((key, count) => {
          if (data.contentbox.seo.seoKeyword.length - 1 == count) {
            res = res + key;
          } else {
            res = res + key + ", ";
          }
        });
        return res;
      }
    }
  };
  return (
    <Fragment>
      <Helmet>
        <title>{renderTitle()["title"]}</title>
        <meta name="description" content={renderTitle()["desc"]} />
        <meta name="keywords" content={rendeKeyWords()} />
        <link rel="canonical" href={window.origin + `${pathname}`} />
        {data?.category?.seo?.seoSchema &&          
          <script type="application/ld+json">
            {data.category.seo.seoSchema}
          </script>
        }
      </Helmet>
      <div className="background-gray" id="reserve-page">
        <Search
          landingLoading={loading}
          isCity={renderCategory().city}
          renderItem={() => {
            return (
              <div className="content-slider">
                {renderCategory().sliderBox && renderCategory().sliderBox()}
              </div>
            );
          }}
          allcitys={data.cities}
          selected={renderCategory().id}
        />
        <div className="container">

          {/* شهرهای فعال */}
          <Cities loading={loading} />

          {/* اسلایدر با تخفیف بخر */}
          <OffSlider data={data} loading={loading} />

          {/* اون چهارتا بیلبورد */}
          {/* <AdvertisingBoxes /> */}

          {/* اسلایدر رزروها */}
          <ReserveBox
            data={data}
            loading={loading}
            renderCategory={renderCategory}
          />

          {/* معرفی اپ نیکوتن */}
          <Mobile />

          {/* دکمه های پایین */}
          <SelectCity
            data={data}
            loading={loading}
            renderCategory={renderCategory}
          />
        </div>
      </div>
    </Fragment>
  );
}

export default ReservePage;
